import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useProcessApiClient } from '@/api/clients/useProcessApiClient.util.ts';
import { ResourceIdDto, ResourceNoteCreationRequestDto, ResourceNoteIdDto } from '@/api/generated';

type Req = ResourceNoteCreationRequestDto & {
  resource: ResourceIdDto;
};

type Response = ResourceNoteIdDto;

type Return = {
  addResourceNote: (req: Req) => Promise<Response>;
  isAddingResourceNote: boolean;
};

export const useAddNoteToResource = (params?: { disableSuccessAlert?: boolean }): Return => {
  const { resourceNoteApi } = useProcessApiClient();

  const { isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    meta: { disableSuccessAlert: params?.disableSuccessAlert ?? false },
    mutationFn: async req => {
      const { data } = await resourceNoteApi.addNote(
        req.resource.resourceId,
        req.resource.type,
        req,
      );
      return data;
    },
  });
  return {
    addResourceNote: mutateAsync,
    isAddingResourceNote: isPending,
  };
};
